// @ts-nocheck
import styled from 'styled-components';

export const CoverageStudySectionStyle = styled.section`
  --container-width: 936px;
  --section-top-margin: 32px;
  --content-margin-top: 16px;
  --background-color: #223046;

  background-color: var(--color-taptap-primary-white);

  .coverageStudySection {
    display: flex;
    align-items: center;

    &__header {
      background-color: var(--background-color);

      &Content {
        height: 48px;
        width: var(--container-width);
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;

        &Back {
          all: unset;
          cursor: pointer;
          color: var(--color-sonata-interaction-500);
        }

        &Message {
          font: var(--font-title-400-bold);
          color: var(--color-sonata-secondary-white);
        }
      }
    }

    &__main {
      width: var(--container-width);
      margin: auto;

      &General {
        margin-top: var(--section-top-margin);
        
        &Content {
          margin-top: var(--content-margin-top);
          display: flex;
          gap: 16px;
        }

        &Name {
          flex: 1;
        }

        &Level {
          flex: 2;

          .iconTooltip__iconTooltipRef i {
            color: var(--color-sonata-interaction-500) !important;
          }

        }

        .customInputLabelUi div {
          display: flex;
          align-items: center;
        }
         
      }

      &View {
        margin-top: var(--section-top-margin);

        &Description {
          display: block;
          margin: 8px 0 16px 0;
          font: var(--font-title-400-regular);
          color: var(--color-sonata-primary-500);
          font-size: 14px;
        }
      }

      &Variables {
        margin-top: var(--section-top-margin);

        &Content {
          margin-top: var(--content-margin-top);
        }

      }

      &Radius {
        margin-top: var(--section-top-margin);

        &Content {
          margin-top: var(--content-margin-top);
        }
      }

      &Buttons {
        width: var(--container-width);
        margin: auto;
        margin-top: 32px;
        border-top: 2px solid black;
      }
    }

    &__footer {
      height: 48px;
      margin-top: 48px;
      background-color: var(--background-color);
    }

    &__sectionTitle {
      font: var(--font-title-400-bold);
      color: #39414F;
    }
  }
`;
